<mat-form-field class="select-input-field" appearance="fill" [style.width]="width + '%'">
  <mat-label>{{'propertypreviewEditor.header' | translate}}</mat-label>
  <input matInput type="text"
         placeholder="text"
         autocomplete="off"
         [(ngModel)]="value"
         [formControl]="formCtrl"
         (click)="showOverlay()"
         (blur)="hideOverlay()"
         (ngModelChange)="inputEmit()" />
  <div class="options-content" *ngIf="isShowOverlay">
    <mat-option *ngFor="let option of displayOptions"
                class="mat-option-content"
                [ngClass]="{'isSelect': option.value === value}"
                [value]="option.value"
                (click)="selectValue(option.value)">
      <span class="option-label-overflow">
        {{replaceLabel('objects.' + option.label | translate)}}
      </span>
    </mat-option>
  </div>
</mat-form-field>
